module.exports = __webpack_public_path__ + "static/media/bomb.b597c4f6.svg";